export enum ShiftStatus {
  INVENTORY = 'inventory',
  OPEN = 'open',
  CLOSED = 'closed',
}
